const HSTRoles = {
    CenterBillingPayment: { roleId: 1, name: 'Center Billing & Payment' },
    MaterialManagement: { roleId: 2, name: 'Material Management' },
    BillingPayment: { roleId: 3, name: 'Billing & Payment' },
    EChartClinical: { roleId: 4, name: 'E-Chart Clinical' },
    EChartSuperUser: { roleId: 5, name: 'E-Chart Super User' },
    CertifiedSterileTech: { roleId: 6, name: 'Certified Sterile Tech' },
    SchedulerFrontDesk: { roleId: 7, name: 'Scheduler/Front Desk' },
};
export { HSTRoles };